import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { ICON_TYPE } from "../../../../../custom/icons/icon.model";
import { CustomUpdatePasswordComponentService } from './custom-update-password-component.service';

@Component({
  selector: 'cx-update-password',
  templateUrl: './custom-update-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomUpdatePasswordComponent {
  form: UntypedFormGroup = this.customUpdatePasswordComponentService.form;
  isUpdating$: Observable<boolean> = this.customUpdatePasswordComponentService.isUpdating$;
  iconTypes = ICON_TYPE;

  showPasswordOld = false;
  showPassword = false;
  showPasswordConfirm = false;

  isPasswordHiddenOld(): void {
    this.showPasswordOld = !this.showPasswordOld;
  }

  isPasswordHidden(): void {
    this.showPassword = !this.showPassword;
  }

  isPasswordHiddenConfirm(): void {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  constructor(private customUpdatePasswordComponentService: CustomUpdatePasswordComponentService) {
  }

  onSubmit(): void {
    this.customUpdatePasswordComponentService.updatePassword();
  }

}
